module.exports = __webpack_public_path__ + "img/11.89fc21c8.webp";